// extracted by mini-css-extract-plugin
export default {"resizableDialog":"ToolModal_resizableDialog__kx6gq","resizableContent":"ToolModal_resizableContent__K-vJA"};